import PropTypes from "prop-types";
import { connect } from 'react-redux';
import React , {useEffect} from "react";
import { useHistory } from "react-router-dom";
import { Tabs, Tab } from "react-tabs-scrollable";
import "../../assets/css/rts.css";
import {getIndividualCate} from "../../helpers/product";
import { multilanguage } from "redux-multilanguage";

const CategoryTab = ( {products,currentLanguageCode, strings} ) => {   
  const history = useHistory();
  const types = getIndividualCate(products);
  const [activeTab, setActiveTab] = React.useState(-1);
 
  const onTabClick = (e, index) => {
  //  console.log(index);
    setActiveTab(index);
    let content=index.toString();
    let type="category";
    if (index===1)
     type='new'
    else if (index===2)
     type='saleItems'
    else if (index===3)
     type='bestSellers'
    else if (index!=0) {
      let idx=index-4;
      content=types[idx].catecode[0];
    }
    if (index===0)
     content="";  
     history.replace({
      ...history.location,
      state: {
          ...history.location.state,
          type: type,
          content: content,
          offset: 0
      }
    })    
    history.push({
      pathname: "/shop", 
      state: { type: type, content: content, offset: 0 }
    })
  };

  useEffect(() =>{
     if (history.location.state?.content==="") 
      setActiveTab(0);
     else if (history.location.state?.content==='1' || history.location.state?.content==='2' || history.location.state?.content==='3' )
     {
      setActiveTab(parseInt(history.location.state?.content));
     } 
     else if (history.location.state?.content)
     {
       let index = types.findIndex(x => x.catecode[0]===history.location.state?.content)
        if (index>=0) 
         setActiveTab(index+4);
     }
  },[history.location.state?.content]);

  return (
    <>
      <Tabs id="tabs-container"
        activeTab={activeTab} 
        onTabClick={onTabClick}
        hideNavBtnsOnMobile={true}
        rightBtnIcon={">"}
        leftBtnIcon={"<"}
        showTabsScroll={true}
       /* tabsContainerStyle={{ backgroundColor: "lightblue", border: "1px solid gray",
                             color: "purple", fontWeight: "bold", padding: "0px 0px"
                           }} */
      >
        <Tab
          key={0}>
           {strings["all_categories"]}
        </Tab>
        <Tab
          key={1}>
           {strings["new_arrival"]}
        </Tab>
        <Tab
          key={2}>
           {strings["sale_items"]}
        </Tab>
        <Tab
          key={3}>
           {strings["best_sellers"]}
        </Tab>
        {types.map((type,index) => (
          <Tab 
            key={index+4}>            
            { currentLanguageCode==='zh'? type.category[0]: type.categoryen[0]}
          </Tab>
          
        ))}
      </Tabs>
      <p />
    </>
  );
}

CategoryTab.propTypes = {
    products: PropTypes.array
  };
  
  const mapStateToProps = state => {
    return{
        products: state.productData.products
    }
  };
  
  export default connect(mapStateToProps)(multilanguage(CategoryTab));